import { Layout } from '@loadsmart/miranda-react'

import type { Shipment } from '../domain/Shipment'
import ShipmentTimeline from './ShipmentTimeline'
import { ShipmentLocationsProvider } from './tracking/ShipmentLocationsContext'
import { TrackingVisibilityCard } from './tracking/TrackingVisibilityCard'

type TrackAndTraceProps = {
  shipment: Shipment
  refetchShipment: (uuid: string) => Promise<void>
}

export function TrackAndTrace({ shipment, refetchShipment }: TrackAndTraceProps) {
  return (
    <ShipmentLocationsProvider shipment={shipment}>
      <Layout.Stack>
        <TrackingVisibilityCard shipment={shipment} refetchShipment={refetchShipment} />
        <ShipmentTimeline shipment={shipment} refetchShipment={refetchShipment} />
      </Layout.Stack>
    </ShipmentLocationsProvider>
  )
}
